import React, { Component } from 'react';
import { withLocalize } from 'react-localize-redux';
import { Header, Button, Form } from 'semantic-ui-react';
import styled from 'styled-components';
import EventFormListingPreview from './eventFormListingPreview';
import EventFormDetailPreview from './eventFormDetailPreview';
import CreateEventQuitModal from '../events/components/createEventQuitModal';

const FormHeader = styled.div`
  font-family: 'Inter';
  font-weight: 900;
  font-size: 24px;
  line-height: 29.05px;
  font-style: normal;
  color: #333333;
  padding-bottom: 10px;
`;

class EventFormPreview extends Component {
  resizeIframe = () => {
    this.iframeObj.setAttribute(
      'style',
      `height: ${this.iframeObj.contentWindow.document.body.scrollHeight}px`
    );
  };

  back = e => {
    e.preventDefault();
    this.props.prevStep();
  };

  render() {
    const {
      values,
      translate,
      activeLanguage,
      isEditing,
      isSubmitting,
      handleSubmit
    } = this.props;

    return (
      <div className='create-event-container'>
        <CreateEventQuitModal />
        <Form className='cms-create-event-form' onSubmit={handleSubmit}>
          <div
            className='create-event-form-header'
          >
            <FormHeader>
              {translate('createEvent.form.header.preview')}
            </FormHeader>
          </div>
          <div className='ui grid'>
            <div
              className='eleven wide column main cms-create-event-form' id='previewDetail'
            >
              <section>
                <Header className='subtitle'>
                  {translate('eventPreviewDetail')}
                </Header>

                <EventFormDetailPreview {...this.props} />
              </section>
            </div>

            <div className='five wide column main cms-create-event-form'>
              <section >
                <Header className='subtitle'>
                  {translate('eventPreviewListing')}
                </Header>
                <br />
                <EventFormListingPreview
                  values={values}
                  activeLanguage={activeLanguage}
                />
              </section>

              <br />

              <div className='prevBtn'>
                <Button onClick={this.back}>
                  {translate('createEvent.backBtn.preview')}
                </Button>
              </div>
              <div className='nextBtn'>
                <Button
                  type='submit'
                  loading={isSubmitting}
                  disabled={isSubmitting}
                >
                  {isEditing
                    ? translate('Done Editing')
                    : translate('Create Event')}
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

export default withLocalize(EventFormPreview);



// WEBPACK FOOTER //
// ./src/components/forms/eventFormPreview.js